let theatreProject = null
let theatreInitPromise = null

export async function ensureTheatreProject() {
  if (theatreProject) {
    return theatreProject
  }

  if (!theatreInitPromise) {
    theatreInitPromise = Promise.all([import('@theatre/core'), import('../data/animation.json')])
      .then(([theatreCore, animationState]) => {
        theatreProject = theatreCore.getProject('performanse', { state: animationState.default })
        return theatreProject
      })
      .catch((error) => {
        theatreInitPromise = null
        throw error
      })
  }

  return theatreInitPromise
}

export function getTheatreProject() {
  return theatreProject
}

export function getTheatreSheet(name) {
  if (!theatreProject) {
    throw new Error('Theatre project not initialized. Call ensureTheatreProject() first.')
  }

  return theatreProject.sheet(name)
}
